import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  isIncomingOrOutgoing: false,
  isSdkReady: false,
  ongoingCallTime: 0,
  isDiscardButtonDisabled: true,
};
export const sliceKey = 'callStatus';

export const callStatusSlice = createSlice({
  name: sliceKey,
  initialState,
  reducers: {
    setCallStatus: (state, { payload }) => {
      try {
        state.isIncomingOrOutgoing = payload;
      } catch (e) {
        console.log(e);
      }
    },
    setSdkClientStatus: (state, { payload }) => {
      try {
        state.isSdkReady = payload;
      } catch (e) {
        console.log(e);
      }
    },
    setOngoingCallTime: (state, { payload }) => {
      try {
        payload === 'reset'
          ? (state.ongoingCallTime = 0)
          : (state.ongoingCallTime = state.ongoingCallTime + 1);
      } catch (e) {
        console.log(e);
      }
    },
    setIsDiscardButtonDisabled: (state, { payload }) => {
      try {
        state.isDiscardButtonDisabled = payload;
      } catch (e) {
        console.log(e);
      }
    },
  },
});

export const {
  setCallStatus,
  setSdkClientStatus,
  setOngoingCallTime,
  setIsDiscardButtonDisabled,
} = callStatusSlice.actions;

export default callStatusSlice.reducer;
